module.exports = "<ng-template #contentTemplate>\r\n    <ng-content></ng-content>\r\n    <tooltip *ngIf=\"tooltip\"\r\n             position=\"bottom\">\r\n        {{tooltip}}\r\n    </tooltip>\r\n</ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client-src/app/core/components/container/nested/item/container-item.nested.html
// module id = ./client-src/app/core/components/container/nested/item/container-item.nested.html
// module chunks = main